import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ImageTypes } from "enums/imageTypes";
import { useApi } from "hooks/useApi";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useNotification } from "./useNotification";

export const useUploadEntityImage = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const callApi = useApi();
  const { showSuccessNotification } = useNotification();

  return useMutation<any, any, any, any>({
    mutationFn: ({ entityId, data, imageType = ImageTypes.Logo }) => {
      return callApi(`/${sport}/o/${organizationId}/entities/${entityId}/image/${imageType}`, {
        method: "PUT",
        body: data,
      });
    },
    onSuccess: (_, { entityId }) => {
      queryClient.invalidateQueries({
        queryKey: ["entity", sport, organizationId, entityId],
      });
      queryClient.invalidateQueries({
        queryKey: ["entities", sport, organizationId],
      });
      showSuccessNotification(formatMessage({ id: "notification.entity.updated" }));
    },
  });
};

export const useDeleteEntityImage = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const callApi = useApi();
  const { showSuccessNotification } = useNotification();

  return useMutation<any, any, any, any>({
    mutationFn: ({ entityId, imageId }) => {
      return callApi(`/${sport}/o/${organizationId}/entities/${entityId}/image/${imageId}`, {
        method: "DELETE",
        body: undefined,
      });
    },
    onSuccess: (_, { entityId }) => {
      queryClient.invalidateQueries({
        queryKey: ["entity", sport, organizationId, entityId],
      });
      queryClient.invalidateQueries({
        queryKey: ["entities", sport, organizationId],
      });
      showSuccessNotification(formatMessage({ id: "notification.entity.updated" }));
    },
  });
};
